import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["control", "item", "list"]
  static values = { current: String }

  connect() {
    this.updateControls()
  }

  sort(event) {
    event.preventDefault()

    const sortValue = event.currentTarget.dataset.playerSortValue || "name"
    this.currentValue = sortValue

    const sortedItems = [...this.itemTargets].sort((firstItem, secondItem) => {
      if (sortValue === "pirat") return this.compareByPirat(firstItem, secondItem)

      return this.compareByName(firstItem, secondItem)
    })

    sortedItems.forEach((item) => this.listTarget.appendChild(item))
    this.updateControls()
    this.updateUrl(sortValue)
  }

  compareByName(firstItem, secondItem) {
    const nameComparison = this.nameFor(firstItem).localeCompare(this.nameFor(secondItem), undefined, { sensitivity: "base" })
    if (nameComparison !== 0) return nameComparison

    return this.compareByPirat(firstItem, secondItem)
  }

  compareByPirat(firstItem, secondItem) {
    const firstPirat = this.piratFor(firstItem)
    const secondPirat = this.piratFor(secondItem)
    const firstMissing = Number.isNaN(firstPirat)
    const secondMissing = Number.isNaN(secondPirat)

    if (firstMissing && !secondMissing) return 1
    if (!firstMissing && secondMissing) return -1
    if (!firstMissing && !secondMissing && firstPirat !== secondPirat) return secondPirat - firstPirat

    return this.nameFor(firstItem).localeCompare(this.nameFor(secondItem), undefined, { sensitivity: "base" })
  }

  nameFor(item) {
    return item.dataset.playerSortName || ""
  }

  piratFor(item) {
    return Number.parseFloat(item.dataset.playerSortPirat || "")
  }

  updateControls() {
    this.controlTargets.forEach((control) => {
      const active = control.dataset.playerSortValue === this.currentValue
      control.classList.toggle("bg-stone-900", active)
      control.classList.toggle("text-white", active)
      control.classList.toggle("text-stone-700", !active)
      control.classList.toggle("hover:bg-stone-100", !active)
    })
  }

  updateUrl(sortValue) {
    const url = new URL(window.location.href)
    url.searchParams.set("players_sort", sortValue)
    window.history.replaceState({}, "", url)
  }
}
